import { Injectable } from "@angular/core";
import { Model_Workflow } from 'src/app/app.models';
import { WorkflowOfflineDao } from './workflow-offline.dao';

const TB_WORKFLOWS_NAME = "LOCAL_TB_WORKFLOWS";

@Injectable()
export class WorkflowOfflineWebDao extends WorkflowOfflineDao {
    doSyncWorkflowsAction(_workflows: Model_Workflow[]): Promise<void> {
        return new Promise((resolve, reject) => {
            this.doClearWorkflowsAction();
            this.doInsertWorkflowsAction(_workflows).then(() => {
                resolve();
            }, err => reject(err));
        });
    }

    doClearWorkflowsAction() {
        return new Promise<void>((resolve, reject) => {
            localStorage.setItem(TB_WORKFLOWS_NAME, "[]");
            resolve();
        });
    }

    doGetWorkflowsAction(): Promise<Model_Workflow[]> {
        return new Promise((resolve, reject) => {
            var datas: Model_Workflow[] = [];
            const storageDatas = localStorage.getItem(TB_WORKFLOWS_NAME);
            if (!!storageDatas && storageDatas != 'undefined' && storageDatas != 'null') {
                try {
                    datas = JSON.parse(storageDatas);
                } catch(e) { console.log(e) }
            }
            resolve(datas);
        });
    }

    doCountWorkflowsAction(): number {
      let count = 0;
      try {
        const workflows = JSON.parse(localStorage.getItem(TB_WORKFLOWS_NAME));
        count = workflows.length;
      } catch(e) { console.log(e) }
      return count;
    }

    doInsertWorkflowsAction(_workflows: Model_Workflow[]): Promise<void> {
        return new Promise((resolve, reject) => {
            this.doGetWorkflowsAction().then((_datasTable: Model_Workflow[]) => {
                var newDatas = _datasTable.concat(_workflows);
                localStorage.setItem(TB_WORKFLOWS_NAME, JSON.stringify(newDatas));
                resolve();
            }, err => reject(err));
        });
    }

    doGetWorkflowAction(_numWorkflow: string): Promise<Model_Workflow> {
        return new Promise((resolve, reject) => {
            this.doGetWorkflowsAction().then((_datasTable: Model_Workflow[]) => {
                const workflow = _datasTable.find(w => w.NUM_WORKFLOW == _numWorkflow);
                resolve(workflow);
            }, err => reject(err));
        });
    }
}
